import {createContext, PropsWithChildren, useContext} from "react";

const PopperZIndexContext = createContext<number|undefined>(undefined);

export function PopperZIndexProvider(props: PropsWithChildren<{
    value: number;
}>) {
    return (
        <PopperZIndexContext.Provider value={props.value}>
            {props.children}
        </PopperZIndexContext.Provider>
    )
}

export function usePopperZIndex() {
    return useContext(PopperZIndexContext);
}